import {
  AlignmentType,
  Document,
  ImageRun,
  Paragraph,
  VerticalAlign,
  PageNumber,
  TextRun,
} from "docx";

import * as docx from "docx";

import {
  breakLine,
  DocXTableColumn,
  table,
  text,
} from "../../../company-office/request-vehicle/TemplateDocx/Template/common";
import { logoBase64 } from "../../../info-technology-process/repair-tools/base64";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";

export const exportWarehouseDocx = (item: any) => {
  const imageData = logoBase64;

  const jsonString = item.fields.eContent;
  const dataArray = JSON.parse(jsonString);

  const eTypeExportWarehouse = item.fields.eTypeExportWarehouse;

  const warehouseMaterialType = [
    "All",
    "Văn phòng phẩm",
    "Công cụ dụng cụ",
    "Nguyên vật liệu",
    "Trang phục/BHLĐ",
    "Thiết bị/TTB",
    "Vật tư VSMB",
  ];

  let evidence: any[];
  try {
    evidence = JSON.parse(item?.fields?.eFileContent);
  } catch (error) {
    evidence = [];
  }
  if (!Array.isArray(evidence)) {
    evidence = [];
  }

  const columnsList: DocXTableColumn<{
    productName: string;
    Dram: string;
    requestedQuantity: string;
    inventoryQuantity: string;
    productLifetime: string;
    note: string;
    approvedQuantity: string;
  }>[] = [
    {
      label: "STT",
      renderText: (item, index) => text((index + 1).toString()),
    },
    {
      label: "Tên vật tư, hàng hóa",
      renderText: (item) => text(item.productName.toString()),
    },
    {
      label: "ĐVT",
      renderText: (item) => text(item.Dram.toString()),
    },
    {
      label: "Số lượng đề nghị",
      renderText: (item) => text(item.requestedQuantity.toString()),
    },
    {
      label: "Số lượng tồn tại đơn vị",
      renderText: (item) => text(item.inventoryQuantity.toString()),
    },
    {
      label: "Thời gian sử dụng",
      renderText: (item) => text(getDDMMYYYFormat(item.productLifetime)),
    },
    {
      label: "Ghi chú",
      renderText: (item) => text(item.note?.toString() || ""),
    },
    {
      label: "Số lượng phê duyệt",
      renderText: (item) => text(item.approvedQuantity?.toString() || ""),
    },
  ];

  return new Document({
    sections: [
      {
        headers: {
          default: new docx.Header({
            children: [
              new docx.Table({
                rows: [
                  new docx.TableRow({
                    children: [
                      new docx.TableCell({
                        children: [
                          new docx.Paragraph({
                            children: [
                              new ImageRun({
                                data: imageData,
                                transformation: {
                                  width: 150,
                                  height: 50,
                                },
                              }),
                            ],
                            alignment: AlignmentType.CENTER,
                          }),
                        ],
                        width: { size: 3000, type: docx.WidthType.DXA },
                        verticalAlign: VerticalAlign.CENTER,
                      }),

                      new docx.TableCell({
                        children: [
                          new docx.Paragraph({
                            children: [
                              new docx.TextRun({
                                text: "Biểu mẫu",
                                bold: true,
                                size: 24,
                                color: "000000",
                                italics: true,
                              }),
                            ],
                            alignment: AlignmentType.LEFT,
                          }),

                          new docx.Paragraph({
                            children: [
                              new docx.TextRun({
                                text: "PHIẾU ĐỀ NGHỊ XUẤT KHO",
                                bold: true,
                                size: 24,
                                color: "000000",
                              }),

                              new docx.TextRun({
                                break: 1,
                                text: "(hàng hóa, vật tư, công cụ dụng cụ thông thường)",
                                size: 24,
                                color: "000000",
                              }),
                            ],
                            spacing: {
                              before: 200,
                              after: 200,
                            },
                            alignment: AlignmentType.CENTER,
                          }),
                        ],
                      }),

                      new docx.TableCell({
                        children: [
                          new docx.Paragraph({
                            children: [
                              new docx.TextRun({
                                // text: `Mã số: ${item.fields.eIssueNumber}`,
                                text: "Mã số: V.SPM-F50",
                                size: 24,
                              }),
                              new docx.TextRun({
                                // text: `Lần ban hành: ${item.fields.eIssueTimes}`,
                                text: "Lần ban hành: 01",
                                size: 24,
                                break: 1,
                              }),
                              new docx.TextRun({
                                // text: `Ngày hiệu lực: ${getDDMMYYYFormat(
                                //   item.fields.eIssueEffectiveDate
                                // )}`,
                                text: "Ngày hiệu lực: 20/12/2022",
                                size: 24,
                                break: 1,
                              }),
                              new docx.TextRun({
                                text: "Trang: ",
                                size: 24,
                                break: 1,
                              }),
                              new Paragraph({
                                children: [
                                  new TextRun({
                                    children: [
                                      PageNumber.CURRENT,
                                      "/",
                                      PageNumber.TOTAL_PAGES,
                                    ],
                                    size: 24,
                                  }),
                                ],
                              }),
                            ],
                          }),
                        ],
                        width: { size: 3000, type: docx.WidthType.DXA },
                        margins: {
                          top: 0,
                          bottom: 100,
                          left: 100,
                          right: 100,
                        },
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
        },

        children: [
          breakLine(1),
          breakLine(1),

          new docx.Paragraph({
            children: [
              new docx.TextRun({
                text: `Đơn vị: ${item.fields.eDepartment}`,
                size: 24,
              }),

              new docx.TextRun({
                break: 1,
                text: `Đề nghị xuất kho: `,
                size: 24,
              }),

              new docx.TextRun({
                break: 1,
                text: `Văn phòng phẩm     `,
                size: 24,
              }),
              new docx.SymbolRun({
                char:
                  eTypeExportWarehouse === "Văn phòng phẩm" ||
                  eTypeExportWarehouse === "All"
                    ? "F0FE"
                    : "F071",
                size: 40,
              }),

              new docx.TextRun({
                text: `     Trang phục/BHLĐ  `,
                size: 24,
              }),
              new docx.SymbolRun({
                char:
                  eTypeExportWarehouse === "Trang phục/BHLĐ" ||
                  eTypeExportWarehouse === "All"
                    ? "F0FE"
                    : "F071",
                size: 40,
              }),

              new docx.TextRun({
                break: 1,
                text: `Công cụ dụng cụ     `,
                size: 24,
              }),
              new docx.SymbolRun({
                char:
                  eTypeExportWarehouse === "Công cụ dụng cụ" ||
                  eTypeExportWarehouse === "All"
                    ? "F0FE"
                    : "F071",
                size: 40,
              }),

              new docx.TextRun({
                text: `     Thiết bị/TTB           `,
                size: 24,
              }),
              new docx.SymbolRun({
                char:
                  eTypeExportWarehouse === "Thiết bị/TTB" ||
                  eTypeExportWarehouse === "All"
                    ? "F0FE"
                    : "F071",
                size: 40,
              }),

              new docx.TextRun({
                break: 1,
                text: `Nguyên vật liệu       `,
                size: 24,
              }),
              new docx.SymbolRun({
                char:
                  eTypeExportWarehouse === "Nguyên vật liệu" ||
                  eTypeExportWarehouse === "All"
                    ? "F0FE"
                    : "F071",
                size: 40,
              }),

              new docx.TextRun({
                text: `     Vật tư VSMB          `,
                size: 24,
              }),
              new docx.SymbolRun({
                char:
                  eTypeExportWarehouse === "Vật tư VSMB" ||
                  eTypeExportWarehouse === "All"
                    ? "F0FE"
                    : "F071",
                size: 40,
              }),

              new docx.TextRun({
                break: 1,
                text: `Khác (ghi cụ thể): ${
                  !warehouseMaterialType.includes(eTypeExportWarehouse)
                    ? eTypeExportWarehouse
                    : ""
                }`,
                size: 24,
              }),
            ],
          }),

          new docx.Paragraph({
            children: [
              new docx.TextRun({
                break: 1,
                text: `Lý do: ${item.fields.eReason}`,
                size: 24,
              }),
              new docx.TextRun({
                break: 1,
                text: `Chứng từ kèm theo (nếu có):`,
                size: 24,
              }),

              ...evidence.map(
                (value) =>
                  new docx.ExternalHyperlink({
                    children: [
                      new TextRun({
                        break: 1,
                        text: `${value.name}`,
                        style: "Hyperlink",
                      }),
                    ],
                    link: value?.response?.data?.[0],
                  })
              ),
            ],
          }),

          breakLine(1),

          table({
            columns: columnsList,
            data: dataArray,
          }),

          breakLine(1),

          new docx.Table({
            rows: [
              new docx.TableRow({
                children: [
                  new docx.TableCell({
                    borders: {
                      top: { style: docx.BorderStyle.NIL },
                      bottom: { style: docx.BorderStyle.NIL },
                      left: { style: docx.BorderStyle.NIL },
                      right: { style: docx.BorderStyle.NIL },
                    },
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            break: 1,
                            text: "PHÒNG KẾ HOẠCH ĐẦU TƯ",
                            bold: true,
                            size: 24,
                          }),
                        ],
                        alignment: AlignmentType.CENTER,
                      }),
                    ],
                    width: { size: "33%", type: docx.WidthType.PERCENTAGE },
                    verticalAlign: VerticalAlign.CENTER,
                  }),

                  new docx.TableCell({
                    borders: {
                      top: { style: docx.BorderStyle.NIL },
                      bottom: { style: docx.BorderStyle.NIL },
                      left: { style: docx.BorderStyle.NIL },
                      right: { style: docx.BorderStyle.NIL },
                    },
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            break: 1,
                            text: "THỦ TRƯỞNG ĐƠN VỊ SỬ DỤNG",
                            bold: true,
                            size: 24,
                          }),
                        ],
                        alignment: AlignmentType.CENTER,
                      }),
                    ],
                    width: { size: "33%", type: docx.WidthType.PERCENTAGE },
                  }),

                  new docx.TableCell({
                    borders: {
                      top: { style: docx.BorderStyle.NIL },
                      bottom: { style: docx.BorderStyle.NIL },
                      left: { style: docx.BorderStyle.NIL },
                      right: { style: docx.BorderStyle.NIL },
                    },
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            break: 1,
                            text: "Ngày    tháng     năm 20…",
                            italics: true,
                            size: 24,
                          }),
                          new docx.TextRun({
                            break: 1,
                            text: "       NGƯỜI LẬP",
                            bold: true,
                          }),
                        ],
                      }),
                    ],
                    width: { size: "33%", type: docx.WidthType.PERCENTAGE },
                    margins: {
                      top: 0,
                      bottom: 100,
                      left: 100,
                      right: 100,
                    },
                    verticalAlign: VerticalAlign.CENTER,
                  }),
                ],
              }),
            ],
          }),
        ],
      },
    ],
  });
};
